import { invokeStream, newSessionId } from './AgentCoreStream';

/**
 * The booking AI overview, streamed as it is written.
 *
 * ONLY EVER CALLED ON A GENUINE FIRST GENERATION. The panel asks
 * `AiOverviewService.getForBooking` first; a stored briefing comes back from
 * that single Mongo read and is painted at once. This module is reached only
 * when there is no stored briefing for the booking, the fingerprint and the
 * reader's language — which is to say, only when text is genuinely being
 * written for the first time. Nothing here animates cached text, and there
 * is no code path that could: the events carry prose only while a model is
 * producing it.
 *
 * SESSION ID. Fresh per call, never the chat's. The runtime rejects
 * concurrent invocations on one session, and opening a booking while a chat
 * reply is still streaming is an ordinary thing to do; a shared id would
 * make one cancel the other. Nothing is lost by a new id because the
 * overview branch of the runtime keeps no conversational state.
 */

export const OVERVIEW_SESSION_PREFIX = 'overview';

/**
 * Stream one booking's briefing.
 *
 * `onEvent` receives the runtime's typed events verbatim:
 *   { type: 'overview.cached',   overview, stale }
 *   { type: 'overview.facts',    facts }
 *   { type: 'overview.delta',    content }
 *   { type: 'overview.complete', overview }
 *   { type: 'error',             message, recoverable }
 *
 * Returns `{ aborted }`. Throws only on a transport fault — a generation
 * that failed arrives as an `error` EVENT, because the stream itself
 * succeeded in telling us so.
 */
export const streamForBooking = async (bookingId, { onEvent, signal } = {}) => {
  if (!bookingId) return { aborted: false };
  return invokeStream({
    body: { overview: { booking_id: bookingId } },
    sessionId: newSessionId(OVERVIEW_SESSION_PREFIX),
    signal,
    onEvent,
  });
};

export default { streamForBooking, OVERVIEW_SESSION_PREFIX };
